/**
 * The nine species the legacy Älgobs page exposes as sub-tabs, in the order
 * legacy renders them. Moose is first because it is the default tab.
 *
 * The slugs are ASCII and appear verbatim in the `?species=` search param, so
 * they are part of this page's URL contract: renaming one silently breaks
 * every bookmarked or shared link.
 */
export const OBSERVATION_SPECIES = [
  'moose',
  'bear',
  'wolf',
  'wolverine',
  'lynx',
  'fallow-deer',
  'red-deer',
  'roe-deer',
  'wild-boar',
] as const

export type ObservationSpeciesSlug = (typeof OBSERVATION_SPECIES)[number]

export const DEFAULT_SPECIES: ObservationSpeciesSlug = 'moose'

function isObservationSpeciesSlug(
  value: unknown,
): value is ObservationSpeciesSlug {
  return (
    typeof value === 'string' &&
    (OBSERVATION_SPECIES as readonly string[]).includes(value)
  )
}

/**
 * Resolves a raw `?species=` value to a slug, falling back to the default.
 *
 * The fallback is deliberate rather than an error: the value comes from the
 * URL, so a stale bookmark, a hand-edited address or a link from an older
 * release can all carry something unusable. Landing on Moose is strictly
 * better than blanking the page over a query string.
 */
export function parseSpeciesSlug(value: unknown): ObservationSpeciesSlug {
  return isObservationSpeciesSlug(value) ? value : DEFAULT_SPECIES
}
